export default class Tile {
    // czy ukryty
    hidden: boolean;
    // czy wylosowany jako oznaczony
    typed: boolean;
    rotate: boolean;
    highlight: boolean;
    constructor(hidden: boolean, typed: boolean) {
        this.hidden = hidden;
        this.typed = typed;
        this.rotate = false;
        this.highlight = false;
    }
}